import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';
import { fuseAnimations } from '../../../../../core/animations';

/** Service file */
import { EcommerceOrderService } from './order.service';

/** Local file */
import { Order } from './order.model';
import { order, spekwo, orderStatuses, toastMsg } from '../../utils/index';

/**Local component */

import { ToastComponent } from '../../common/toast.component';


@Component({
    selector: 'fuse-e-commerce-order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class FuseEcommerceOrderComponent {

    orderValues = order;
    spekwoValues = spekwo;
    orderStatuses = orderStatuses;
    toastMsg = toastMsg;

    order = new Order();

    onOrderChangedSubscription: Subscription;

    statusForm: FormGroup;

    currentStatus: any;

    statusColor: string;

    orderDetailSpinner: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        public route: ActivatedRoute,

        /** Local component */
        public toastComponent: ToastComponent,

        /** Service file */
        private orderService: EcommerceOrderService,
    ) {
    }

    ngOnInit() {

        this.orderDetailSpinner = true;
        // get current order from params
        this.route.params.subscribe(params => {

            this.orderService.getOrder(params.id)
                .then(() => {

                    // Subscribe to update order on changes
                    this.onOrderChangedSubscription =
                        this.orderService.onOrderChanged
                            .subscribe(order => {
                                this.order = new Order(order);
                            });

                    this.currentStatus = this.order.status;
                    this.orderDetailSpinner = false;

                    this.statusForm = this.formBuilder.group({
                        newStatus: [this.order.status]
                    });

                    //Get color for order's status
                    this.statusColorApply(this.currentStatus);

                })
                .catch(() => {
                    this.orderDetailSpinner = false;
                })

        }, () => {
            this.orderDetailSpinner = false;
        });

    }

    ngOnDestroy() {
        this.onOrderChangedSubscription && this.onOrderChangedSubscription.unsubscribe();
    }

    statusColorApply(value) {
        for (const status of this.orderStatuses) {
            if (status.id === value) {
                this.statusColor = status.color;
            }
        }
    }

    //Update order status
    updateStatus(orderId) {
        var newStatusId = this.statusForm.get('newStatus').value;

        if (!newStatusId) {
            return;
        }

        var newStatus = this.orderStatuses.find((status) => {
            return status.id === newStatusId;
        });

        newStatus['date'] = new Date().toString();

        this.orderService.saveOrder(orderId, newStatusId);

        // Show the success message
        this.toastComponent.showToast(this.toastMsg.statusUpdated);

        this.currentStatus = newStatusId;

        this.statusColorApply(this.currentStatus);
    }

    //Check empty object or not
    isObject(obj) {
        return _.isEmpty(obj);
    }


}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/order/order.component.ts